import { experienceBuilderApi } from 'api'

export const fetchPractitionerLocations = () =>
  experienceBuilderApi.get<{ data: any[] }>('/marketing-capabilities/practitioners/locations')
